import { useGlobalConfig } from "@tlc/ls2pac/components/GlobalConfig";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import React from "react";
import {
  BookJacketAndRating,
  ResourceRowHeader,
  RowHeader,
} from "../lists/ResourceListItem";
import { SerialIssueInformation } from "./SerialIssueInformation";
import { HoldStatus } from "./HoldStatus";
import { ReadingLevels } from "./ReadingLevels";
import { HoldPickupInfo } from "./HoldPickupInfo";
import { CancelHoldButton } from "../CancelHoldButton";
import { Button } from "@mui/material";

export const HoldsRowItem: React.FC<{
  id: string;
  hold: HostSystemItemView;
  onClickSuspend: () => void;
  onClickCancel: () => void;
  onClickReactivate: () => void;
  onClickCheckout: () => void;
}> = ({
  id,
  hold,
  onClickSuspend,
  onClickCancel,
  onClickReactivate,
  onClickCheckout,
}) => {
  const { allowBorrowersToCancelArrivedHolds } = useGlobalConfig();
  const { translate } = useLanguage();

  const displayCancel =
    hold.status !== "T" &&
    (hold.status !== "AR" || allowBorrowersToCancelArrivedHolds);
  const displayReactivateOrSuspend =
    !hold.downloadable && hold.status !== "T" && hold.status !== "AR";
  const displayReactivate = displayReactivateOrSuspend && hold.suspendUntilDate;
  const displaySuspend = displayReactivateOrSuspend && !hold.suspendUntilDate;
  const displayHoldActions = displayCancel || displayReactivateOrSuspend;

  return (
    <>
      <BookJacketAndRating
        id={id}
        resource={hold.resource}
      ></BookJacketAndRating>
      <div className="resourceContentWrapper lightBorder">
        <div className="resourceContent">
          {hold.resource ? (
            <ResourceRowHeader resource={hold.resource}></ResourceRowHeader>
          ) : (
            <RowHeader
              shortTitle={hold.title}
              shortAuthor={hold.author}
            ></RowHeader>
          )}
          <SerialIssueInformation hold={hold}></SerialIssueInformation>
          <ReadingLevels resource={hold.resource}></ReadingLevels>
          <HoldStatus hold={hold} onClickSuspend={onClickSuspend}></HoldStatus>
          <HoldPickupInfo hold={hold}></HoldPickupInfo>
          {displayHoldActions && (
            <div className="actionLinks">
              {displayCancel && <CancelHoldButton onClick={onClickCancel} />}
              {displayCancel && displayReactivateOrSuspend && (
                <> {translate("or")} </>
              )}
              {displayReactivate && (
                <Button onClick={onClickReactivate}>
                  {translate("reactivate")}
                </Button>
              )}
              {displaySuspend && (
                <Button onClick={onClickSuspend}>{translate("suspend")}</Button>
              )}
            </div>
          )}

          <ul className="resultActions clearfix">
            {hold.downloadable && hold.status == "AR" && (
              <li>
                <Button variant="contained" onClick={onClickCheckout}>
                  {translate("checkout")}
                </Button>{" "}
                <span className="byDate">
                  {hold.status == "AR" &&
                    !hold.suspendUntilDate &&
                    hold.holdPickupBy && (
                      <>
                        {translate("by")}{" "}
                        <strong className="pickupDate">
                          {hold.holdPickupByString}
                        </strong>
                      </>
                    )}
                </span>
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};
